/**
 * engagementactions.js.js
 * Created by calhosh on 8/27/2020.
 */
import * as types from '../actiontypes';
import {promiseAreas} from '../../util/uiconstants';
import {getAllEngagementUsersUrl} from '../apiUrls';
import {engagementUserStatus, serviceURL} from '../../util/uiconstants';
import env from '../../util/env';

export function getEngagement(engagementId, isEngagementAccessible) {
	let url = env.getServerUrl();
	if (isEngagementAccessible) {
		url = url + 'Engagements/' + engagementId + '?IncludeEngagementMetaData=true';
	} else {
		url = url + 'Engagements/' + engagementId + '/WithoutIndependence?IncludeEngagementMetaData = true';
	}

	return {
		type: types.GET_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementTeamMembers(url, sortByName = false) {
	return {
		type: types.GET_ENGAGEMENT_TEAM_MEMBERS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		sortByName: sortByName
	};
}

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the active users in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @returns {Object} An action object.
 */
export const getActiveEngagementUsers = (engagementId) => {
	const userStatus = [engagementUserStatus.Active, engagementUserStatus.ScheduledInactive];
	const url = getAllEngagementUsersUrl(engagementId, {userStatus});

	return {
		type: types.GET_ENGAGEMENT_TEAM_MEMBERS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		sortByName: true
	};
};

export function getEngagementMetaData(url) {
	return {
		type: types.LOAD_ENGAGEMENTMETADATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementProfileData(engagementId) {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Profile';

	return {
		type: types.GET_ENGAGEMENT_PROFILE_DATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementUsersWithRoles(url) {
	return {
		type: types.GET_ENGAGEMENT_USERS_WITHROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.USERROLE_SELECTION_AREA
			}
		}
	};
}

export function getCountryStatus(url, resource) {
	return {
		type: types.GET_COUNTRY_STATUS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getEngagementRoles(url, resource) {
	return {
		type: types.GET_ALL_ENGAGEMENT_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getRbacRoles(url, resource) {
	return {
		type: types.GET_ALL_RBAC_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getWorkspaceDetails(url) {
	return {
		type: types.GET_WORKSPACE_METADATA,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getLanguages(url) {
	return {
		type: types.GET_LANGUAGES,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getCountries(url) {
	return {
		type: types.GET_COUNTRIES,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function setEngagementId(engagementId) {
	return {
		type: types.SET_ENGAGEMENT_ID,
		engagementId: engagementId
	};
}

export function setIsAresView(isAresView) {
	return {
		type: types.SET_IS_ARESVIEW,
		isAresView: isAresView
	};
}

export function setIsDrawerMode(isDrawer) {
	return {
		type: types.SET_IS_DRAWER_MODE,
		isDrawer: isDrawer || false
	};
}

export function setIsTrackChangesView(isTrackChangesView) {
	return {
		type: types.SET_IS_TRACK_CHANGES_VIEW,
		isTrackChangesView: isTrackChangesView || false
	};
}

export function setIsCompareResponsesView(isCompareResponsesView) {
	return {
		type: types.SET_IS_COMPARE_RESPONSES_VIEW,
		isCompareResponsesView: isCompareResponsesView || false
	};
}

export function setIsGuidedWorkFlowV2(isGuidedWorkFlowV2) {
	return {
		type: types.SET_IS_GUIDEDWORKFLOWV2,
		isGuidedWorkFlowV2: isGuidedWorkFlowV2 || false
	};
}

export function setHasBodyIdFilter(hasBodyIdFilter) {
	return {
		type: types.SET_HAS_BODY_ID_FILTER,
		hasBodyIdFilter: hasBodyIdFilter || false
	};
}

export function setNavigationIdFilter(navFilter) {
	return {
		type: types.SET_NAVIGATION_FILTER,
		navigationFilter: navFilter || 0
	};
}

export function setValidationFilterValue(leftPanelValidationFilterValue) {
	return {
		type: types.SET_VALIDATION_FILTER_VALUE,
		leftPanelValidationFilterValue: leftPanelValidationFilterValue
	};
}

export function updateEngagement(engagementId, value, path, operation) {
	let url = `${env.getBaseURL(serviceURL, engagementId)}`;
	const data = [{op: operation, path: path, value: value}];

	return {
		type: types.UPDATE_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

export function setTheme(theme) {
	return {
		type: types.SET_THEME,
		theme: theme
	};
}

export function getTheme() {
	return {
		type: types.GET_THEME
	};
}
